import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { USERS, INIT_POSTS } from '../data';
import styles from './UserProfilePage.module.css';

export default function UserProfilePage() {
  const { username } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('contributions');

  // Find user by handle or just use a mock user
  const user = USERS.find(u => `@${u.name.split(' ')[0].toLowerCase()}` === username) || USERS[0];
  const userPosts = INIT_POSTS.filter(p => p.user.id === user.id);

  // Generate mock heatmap data
  const generateHeatmap = () => {
    const weeks = [];
    for (let w = 0; w < 52; w++) {
      const days = [];
      for (let d = 0; d < 7; d++) {
        // Random intensity 0-4
        const intensity = Math.random() > 0.8 ? Math.floor(Math.random() * 4) + 1 : 0;
        days.push(intensity);
      }
      weeks.push(days);
    }
    return weeks;
  };

  const heatmapData = generateHeatmap();

  return (
    <div className={styles.profileContainer}>
      <div className={styles.header}>
         <div className={styles.backBtn} onClick={() => navigate(-1)}>
            <span className={styles.backIcon}>←</span> Back
         </div>
      </div>

      <div className={styles.mainLayout}>
        {/* Left Column: Heatmap, Memberships, Contributions */}
        <div className={styles.contentColumn}>
           
           <div className={styles.sectionCard}>
             <div className={styles.sectionHeader}>
               <h3>Activity</h3>
               <span className={styles.helpIcon} title="Activity heatmap">?</span>
             </div>
             
             <div className={styles.heatmapWrapper}>
               <div className={styles.heatmapGrid}>
                 {heatmapData.map((week, wIndex) => (
                   <div key={wIndex} className={styles.heatmapCol}>
                     {week.map((intensity, dIndex) => (
                       <div key={dIndex} className={`${styles.heatmapBox} ${styles['intensity-' + intensity]}`}></div>
                     ))}
                   </div>
                 ))}
               </div>
               <div className={styles.heatmapLegend}>
                 <span>Less</span>
                 <div className={`${styles.heatmapBox} ${styles['intensity-0']}`}></div>
                 <div className={`${styles.heatmapBox} ${styles['intensity-1']}`}></div>
                 <div className={`${styles.heatmapBox} ${styles['intensity-2']}`}></div>
                 <div className={`${styles.heatmapBox} ${styles['intensity-3']}`}></div>
                 <div className={`${styles.heatmapBox} ${styles['intensity-4']}`}></div>
                 <span>More</span>
               </div>
             </div>
           </div>

           <div className={styles.sectionCard}>
              <div className={styles.sectionHeader}>
                 <h3>Memberships (1)</h3>
              </div>
              <div className={styles.membershipsGrid}>
                 <div className={styles.communityCard}>
                   <div className={styles.communityLogo}>🎓</div>
                   <div className={styles.communityInfo}>
                     <h4>AI Money Lab</h4>
                     <p>2,341 members • $99/month</p>
                   </div>
                 </div>
              </div>
           </div>

           <div className={styles.sectionCard}>
              <div className={styles.sectionHeader}>
                 <h3>Contributions</h3>
                 <select className={styles.communityFilter}>
                   <option>All communities</option>
                   <option>AI Money Lab</option>
                 </select>
              </div>
              
              <div className={styles.tabs}>
                 <div className={`${styles.tab} ${styles.active}`}>Posts & Comments</div>
              </div>

              <div className={styles.feed}>
                 {userPosts.length > 0 ? userPosts.map(post => (
                   <div key={post.id} className={styles.postCard}>
                     <div className={styles.postHeader}>
                       <span className={styles.postContext}>Posted in <strong>General discussion</strong></span>
                       <span className={styles.postTime}>{post.time}</span>
                     </div>
                     <div className={styles.postBody} dangerouslySetInnerHTML={{__html: post.content}}></div>
                     <div className={styles.postActions}>
                       <span>❤️ {post.likes}</span>
                       <span>💬 {post.comments}</span>
                     </div>
                   </div>
                 )) : (
                   <div className={styles.emptyState}>
                      No contributions yet.
                   </div>
                 )}
              </div>
           </div>
        </div>

        {/* Right Column: User Info Card */}
        <div className={styles.sidebarColumn}>
           <div className={styles.userCard}>
              <div className={styles.avatarArea}>
                <div className={styles.largeAvatar}>{user.avatar}</div>
                <div className={styles.levelBadge}>{user.level}</div>
              </div>
              
              <div className={styles.userInfo}>
                 <h2 className={styles.userName}>{user.name}</h2>
                 <p className={styles.userHandle}>@{username || user.name.split(' ')[0].toLowerCase()}</p>
                 <p className={styles.userBio}>Building AI automated workflows. Passionate about community.</p>
                 
                 <div className={styles.userMeta}>
                   <div className={styles.onlineStatus}>
                     <span className={styles.dot}></span> Online now
                   </div>
                   <div className={styles.joinDate}>Joined May 2026</div>
                 </div>
                 
                 <div className={styles.statsRow}>
                   <div className={styles.statBox}>
                     <div className={styles.statNum}>14</div>
                     <div className={styles.statLabel}>Contributions</div>
                   </div>
                   <div className={styles.statBox}>
                     <div className={styles.statNum}>3</div>
                     <div className={styles.statLabel}>Followers</div>
                   </div>
                   <div className={styles.statBox}>
                     <div className={styles.statNum}>1</div>
                     <div className={styles.statLabel}>Following</div>
                   </div>
                 </div>

                 <div className={styles.cardActions}>
                    <button className="btn btn-outline" onClick={() => navigate('/settings')}>EDIT PROFILE</button>
                 </div>
              </div>
           </div>
        </div>
      </div>
    </div>
  );
}
